// src/pages/Orders/components/OrdersFilter.tsx

import React from 'react';
import { OrderFilters } from '../../../app/models/Order';

type Props = {
  filter: OrderFilters;
  setFilter: (filter: OrderFilters) => void;
};

const OrdersFilter = ({ filter, setFilter }: Props) => {
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value, page: 1 });
  };

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;

    // Unificar estado: aplica a transporte y almacén
    if (name === 'transportation_order_status') {
      setFilter({
        ...filter,
        transportation_order_status: value || 'TODOS',
        warehouse_order_status: value || 'TODOS',
        page: 1,
      });
      return;
    }

    setFilter({ ...filter, [name]: value, page: 1 });
  };

  return (
    <div className="row gx-3 gy-2 align-items-end">
      {/* Sector (Tipo de pedido) */}
      <div className="col-auto">
        <label htmlFor="orderType" className="form-label small">Sector</label>
        <select
          id="orderType"
          name="orderType"
          className="form-select form-select-sm"
          value={filter.orderType ?? 'TODOS'}
          onChange={handleSelect}
        >
          <option value="TODOS">Todos</option>
          <option value="Transporte">Transporte</option>
          <option value="Almacenamiento">Almacenamiento</option>
        </select>
      </div>

      {/* Pedido Transporte */}
      <div className="col-auto">
        <label htmlFor="transportation_order_id" className="form-label small">Pedido</label>
        <input
          type="number"
          id="transportation_order_id"
          name="transportation_order_id"
          className="form-control form-control-sm"
          value={filter.transportation_order_id ?? ''}
          onChange={handleInput}
        />
      </div>

      {/* Pedido Almacén (opcional, oculto) */}
      {/* <div className="col-auto">
        <label htmlFor="warehouse_order_id" className="form-label small">Pedido Alm.</label>
        <input
          type="number"
          id="warehouse_order_id"
          name="warehouse_order_id"
          className="form-control form-control-sm"
          value={filter.warehouse_order_id ?? ''}
          onChange={handleInput}
        />
      </div> */}

      {/* Cotización */}
      <div className="col-auto">
        <label htmlFor="quote_id" className="form-label small">Oferta</label>
        <input
          type="number"
          id="quote_id"
          name="quote_id"
          className="form-control form-control-sm"
          value={filter.quote_id ?? ''}
          onChange={handleInput}
        />
      </div>

      {/* Cliente */}
      <div className="col-auto">
        <label htmlFor="client" className="form-label small">Cliente</label>
        <input
          type="text"
          id="client"
          name="client"
          className="form-control form-control-sm"
          value={filter.client ?? ''}
          onChange={handleInput}
        />
      </div>

      {/* Estado (único, aplicado a ambos) */}
      <div className="col-auto">
        <label htmlFor="transportation_order_status" className="form-label small">Estado</label>
        <select
          id="transportation_order_status"
          name="transportation_order_status"
          className="form-select form-select-sm"
          style={{ width: '150px' }}
          value={filter.transportation_order_status ?? 'TODOS'}
          onChange={handleSelect}
        >
          <option value="TODOS">TODOS</option>
          <option value="ACTIVO">Activo</option>
          <option value="FINALIZADO">Finalizado</option>
        </select>
      </div>

      {/* Fecha Desde */}
      <div className="col-auto">
        <label htmlFor="start_date" className="form-label small">Desde</label>
        <input
          type="date"
          id="start_date"
          name="start_date"
          className="form-control form-control-sm"
          value={filter.start_date ?? ''}
          onChange={handleInput}
        />
      </div>

      {/* Fecha Hasta */}
      <div className="col-auto">
        <label htmlFor="end_date" className="form-label small">Hasta</label>
        <input
          type="date"
          id="end_date"
          name="end_date"
          className="form-control form-control-sm"
          value={filter.end_date ?? ''}
          onChange={handleInput}
        />
      </div>
    </div>
  );
};

export default OrdersFilter;
